import type { OrgEmployee } from '@api/OrgEmployeeService';
import { useAllOrgEmployeesEntry } from '@stores/orgEmployeeStore';

const useAllOrgEmployees = (
    orgId: string,
): {
    allOrgEmployees: OrgEmployee[] | undefined;
    isLoadingAllOrgEmployees: boolean;
    fetchAllOrgEmployees: () => void;
} => {
    const {
        response: allOrgEmployees,
        isLoading: isLoadingAllOrgEmployees,
        requestApiCall: fetchAllOrgEmployees,
    } = useAllOrgEmployeesEntry(orgId);

    return {
        allOrgEmployees,
        isLoadingAllOrgEmployees,
        fetchAllOrgEmployees,
    };
};

export default useAllOrgEmployees;
